import { cn } from '@/lib/cn';

/**
 * Page-level horizontal container matching the Stitch grid:
 * 16px (mobile) / 64px (desktop) outer padding, max-width 1200px.
 */
export function Container({
  className,
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'mx-auto w-full max-w-container-max px-margin-mobile md:px-margin-desktop',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
